import queryString from 'qs';

import models from '../../utilities/models.js';
import Query from '../../../shared/query.js';
import rehydrate from '../../utilities/rehydrate.js';
import { replaceLegacyEconomyIds } from '../../utilities/legacy.js';

export const initialState = {
  query: null,
  prevQuery: null,
  results: {
    trades: {
      status: 'pending',
      data: null,
    },
    commodities: {
      status: 'pending',
      data: null,
    },
    exporters: {
      status: 'pending',
      data: null,
    },
    importers: {
      status: 'pending',
      data: null,
    },
    footprints: {
      status: 'pending',
      data: null,
    },
    historical: {
      status: 'pending',
      data: null,
    },
    totals: {
      status: 'pending',
      data: null,
    },
  },
  modalOpen: false,
  shareModalOpen: false,
  activeCountry: null,
  countryModalOpen: false,
  mapLoaded: false,
  hoveredFlow: null,
  hoveredFlowPoint: null,
  hoveredCountry: null,
};

export function getInitialState() {
  const params = queryString.parse(window.location.search.replace(/^\?/, ''));
  // Not much point updating the URL inside an embed
  // FIXME: Ideally we need to send a 301 redirect from the server (Craft)
  const [normalisedParams] = replaceLegacyEconomyIds(params);
  const query = new Query(normalisedParams, models);

  return {
    ...initialState,
    query: query,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case 'RESULTS_LOADED':
      const results = {
        ...state.results,
        [action.id]: {
          status: 'ready',
          // FIXME: Move this condition and make more generic
          data: action.id !== 'footprints' ? rehydrate(action.data, models) : action.data,
        },
      };
      return { ...state, results: results };

    case 'SHOW_MAP':
      return { ...state, mapLoaded: true };

    case 'SET_HOVERED_FLOW':
      if (state.hoveredFlow === action.data) {
        return state;
      }

      return {
        ...state,
        hoveredFlow: action.data,
      };

    case 'SET_HOVERED_COUNTRY':
      if (state.hoveredCountry === action.country) {
        return state;
      }

      return { ...state, hoveredCountry: action.country };

    case 'SET_SHOW_TOOLTIP':
      return {
        ...state,
        showTooltip: action.show,
      };

    default:
      console.warn('Action not implemented');
  }
}
